module.exports = __webpack_public_path__ + "img/apple-touch-icon-152x152.71a40e7f.png";